/**
 * /app/$tenantSlug/settings/checklists/preboarding — Settings › People ›
 * Checklists, Pre-boarding tab (migration 170; spec
 * docs/superpowers/specs/2026-11-02-checklists-preboarding.md §3).
 */

import { createFileRoute } from "@tanstack/react-router";
import { ChecklistsRoutePage } from "@/components/settings/checklists/checklists-route-page";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/settings/checklists/preboarding")({
  component: () => <ChecklistsRoutePage stage="preboarding" />,
});
